module.exports = __webpack_public_path__ + "img/heart-pulse.688b3662.svg";